import React from 'react';
import { checkIsBotUA, checkIsFaceBookBot } from '@utils/ui';
import Script from 'next/script';
import { ANALYTICS_SEGMENT, useAnalyticsActions } from '@integrations/analytics/store/store.analytics';

const SegmentAnalyticsScript = () => {
  /* Analytic Actions */
  const analyticsActions = useAnalyticsActions();

  const isBot = checkIsBotUA();
  /* facebook has a bot, but doesn't include bot in name */
  const isFacebookBot = checkIsFaceBookBot();

  if (isBot || isFacebookBot) {
    return null;
  }

  // Set up a listener to flush queue whenever analytics becomes ready
  // This handles both initial load and events queued after analytics loads
  React.useEffect(() => {
    const setupFlushListener = () => {
      if (typeof window !== 'undefined' && (window as any).analytics) {
        if (typeof (window as any).analytics.ready === 'function') {
          // analytics.ready() can be called multiple times and will fire immediately if already ready
          (window as any).analytics.ready(() => {
            setTimeout(() => {
              analyticsActions.flushQueue(ANALYTICS_SEGMENT);
            }, 100);
          });
        } else {
          // Analytics exists but ready() not available yet, wait and try again
          setTimeout(setupFlushListener, 100);
        }
      } else {
        // Analytics not loaded yet, wait and try again
        setTimeout(setupFlushListener, 100);
      }
    };

    setupFlushListener();
  }, [analyticsActions]);

  return (
    <>
      <Script
        src={`https://cdn.segment.com/analytics.js/v1/${process.env.NEXT_PUBLIC_SEGMENT_KEY}/analytics.min.js`}
        strategy="lazyOnload"
        onReady={() => {
          // Trigger the flush listener setup
          if (typeof window !== 'undefined' && (window as any).analytics) {
            // If analytics is already ready, trigger ready() callback immediately
            if (typeof (window as any).analytics.ready === 'function') {
              (window as any).analytics.ready(() => {
                setTimeout(() => {
                  analyticsActions.flushQueue(ANALYTICS_SEGMENT);
                }, 100);
              });
            }
          }
        }}
      />
    </>
  );
};

export default SegmentAnalyticsScript;
